import { EPtwStatus, EUserGroup, EUserLevels, IProject, IPtw, IUser, ProjectUtils } from '@relab/alstom-ptw-shared';
import moment from 'moment/moment';

export const ptwUtils = {
  isDeletable: (project: IProject, user: IUser, ptw: IPtw) => {
    return (
      (ptw.status !== EPtwStatus.CANCELLATO &&
        ((ptw.status !== EPtwStatus.CHIUSURA_Y && user.userLevel === EUserLevels.Admin) ||
          (ptw.status === EPtwStatus.NUOVO && user._id === ptw.issuer._id))) ||
      (ptw.status === EPtwStatus.NUOVO &&
        ProjectUtils.checkUserPermissionsOnProject(project, user, [EUserGroup.PRTCM, EUserGroup.PRTCM_DELEGATE]) &&
        moment(ptw.createdAt).isBefore(moment().subtract(1, 'month')))
    );
  },
};
